<template>
    <transition name="slider-bottom">
        <div class="toast-module" v-if="toast.toastShow" :class="{animation:isAnimation}">
            <!--预约弹窗-->
            <div class="toast-appointment" v-if="toast.contentShow===1">
                <p><span>到店礼</span>{{toast.shopData.bnfTitle}}<span class="close" @click.stop="closeToast(1)">x</span></p>
                <p><span>预约礼</span>{{toast.shopData.bnfSubTitle}}</p>
                <input type="text" placeholder="请输入手机号码" v-model="toast.mobile" maxlength="11">
                <div class="btn" @click.stop="submitShop">马上预约</div>
            </div>
            <!--预约验证-->
            <div class="toast-verification" v-if="toast.contentShow===2">
                <span class="close" @click.stop="closeToast">x</span>
                <p>为保证收集号码畅通，请输入验证码</p>
                <div class="input">
                    <input type="text" placeholder="请输入验证码" maxlength="6" v-model="verifyCode">
                    <span class="btn-verification" @click.stop="getVericode">{{veriBtnTxt}}</span>
                </div>
                <div class="btn" @click.stop="submitShop(btn)">提交验证码</div>
            </div>
            <!--抽奖机会用完-->
            <div class="toast-over" v-if="toast.contentShow===3">
                <div class="toast-over-conatiner">
                    <div class="close" @click.stop="closeToast"></div>
                    <div class="btn" @click.stop="closeToast"></div>
                </div>
            </div>
            <!--没有中奖弹窗-->
            <div class="toast-null" v-if="toast.contentShow===11">
                <div class="toast-null-conatiner">
                    <div class="close" @click.stop="closeToast"></div>
                    <div class="btn" @click.stop="closeToast"></div>
                </div>
            </div>
            <!--成功弹窗-->
            <div class="toast-success-price" v-if="toast.contentShow===4" v-bind:class="{isTopshow:toast.contentShow == 4}">
                <div class="toast-price-conatiner">
                    <!--<div class="btn"></div>-->
                    <div class="close" @click.stop="closeToast(2)"></div>
                    <div class="btn" @click.stop="lotteryfn"></div>
                </div>
            </div>
            <!--奖品口红弹窗-->
            <div class="toast-lipstick-price" v-if="toast.contentShow===5" v-bind:class="{isRotate:toast.contentShow == 5}">
                <div class="toast-price-conatiner">
                    <div class="price-text" v-text="priceText"></div>
                    <!--<div class="btn"></div>-->
                    <div class="price-img"></div>
                    <div class="close" @click.stop="closeToast"></div>
                    <div class="btn" @click.stop="closeToast"></div>
                </div>
            </div>
            <!--奖品面膜弹窗-->
            <div class="toast-mask-price" v-if="toast.contentShow===6" v-bind:class="{isRotate:toast.contentShow == 6}">
                <div class="toast-price-conatiner">
                    <div class="price-text" v-text="priceText"></div>
                    <!--<div class="btn"></div>-->
                    <div class="price-img"></div>
                    <div class="close" @click.stop="closeToast"></div>
                    <div class="btn" @click.stop="closeToast"></div>
                </div>
            </div>

            <!--奖品花弹窗-->
            <div class="toast-flower-price" v-if="toast.contentShow===7" v-bind:class="{isRotate:toast.contentShow == 7}">
                <div class="toast-price-conatiner">
                    <div class="price-text" v-text="priceText"></div>
                    <!--<div class="btn"></div>-->
                    <div class="price-img"></div>
                    <div class="close" @click.stop="closeToast"></div>
                    <div class="btn" @click.stop="closeToast"></div>
                </div>
            </div>
            <!--奖品5元弹窗-->
            <div class="toast-5-price" v-if="toast.contentShow===8" v-bind:class="{isRotate:toast.contentShow == 8}">
                <div class="toast-price-conatiner">
                    <div class="price-text" v-text="priceText"></div>
                    <!--<div class="btn"></div>-->
                    <div class="price-img"></div>
                    <div class="close" @click.stop="closeToast"></div>
                    <div class="btn" @click.stop="closeToast"></div>
                </div>
            </div>
            <!--奖品520弹窗-->
            <div class="toast-520-price" v-if="toast.contentShow===9" v-bind:class="{isRotate:toast.contentShow == 9}">
                <div class="toast-price-conatiner">
                    <div class="price-text" v-text="priceText"></div>
                    <!--<div class="btn"></div>-->
                    <div class="price-img"></div>
                    <div class="close" @click.stop="closeToast"></div>
                    <div class="btn" @click.stop="closeToast"></div>
                </div>
            </div>
            <!--大奖弹窗-->
            <div class="toast-big-price" v-if="toast.contentShow===10" v-bind:class="{isRotate:toast.contentShow == 10}">
                <div class="toast-price-conatiner">
                    <div class="price-text" v-text="priceText"></div>
                    <!--<div class="btn"></div>-->
                    <div class="price-img"></div>
                    <div class="close" @click.stop="closeToast"></div>
                    <div class="btn" @click.stop="closeToast"></div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
    // ajax
    import Vue from 'vue';
    import { url, data } from '../api/url';
    export default {
        data() {
            return {
                toastShow: "",
                contentShow: "",
                priceText: "恭喜获得娇兰口红一支",
                verifyCode: "",
                veriBtnTxt: "获取验证码",
                toast: {}
            }
        },
        props: ['config'],
        mounted() {
            this.toast = this.config.toast;
        },
        methods: {
            closeToast(index) {
                if (index && index == 1){
                    this.lingxiClick(0,'b_1zcvgmo1');
                }
                if (index && index == 2){
                    this.lingxiClick(0,'b_4kuvlqb6');
                }
                this.toast.contentShow = 0;
                this.toast.toastShow = false;
                this.verifyCode = "";
            },
            lingxiClick (indexs,clickName){
               Analytics('event', {
                    nm:'mge',
                    val_bid: clickName,
                    event_type: 'click', // 可选参数
                    val_lab: { // 默认没有
                        custom: {// val_val 满足不了的信息
                            index: indexs// 这里设置自定义埋点信息
                        }
                    }
                }); 
            },
            /**
            * 预约提交
            */
            submitShop() {
                var self = this;
                data.action = 'wedPromotionOnFebruary201703';
                data.method = 'booking';
                data.shopId = this.toast.shopData.shopId;
                data.mobile = this.toast.mobile;
                data.source = "";
                data.verifyCode = this.verifyCode;
                data.cityId = this.toast.cityId;
                if (!/1\d{10}/.test(this.toast.mobile)) {
                    alert('请输入正确的手机号码');
                    return;
                }

                // 校验验证码
                if (this.toast.contentShow == 2 && this.verifyCode.length == 0) {
                    alert('请输入验证码');
                    return;
                }
                this.lingxiClick(0,'b_k8ofbl1n');
                // jsonp
                Vue.http.jsonp(url,
                    {　　//请求参数
                        params: data
                    }).then(function (res) {
                        let _resBody = res.body,
                            _code = _resBody.code,
                            _msg = _resBody.msg;

                        if (_code == 200) {
                            self.lingxiClick(0,'b_lfuy7g7u');
                            self.$emit('isbooked', self.toast.index);
                            if (_msg.restCount && _msg.restCount != 0) {
                                self.toast.contentShow = 4;
                            } else {
                                self.toast.contentShow = 3;
                                setTimeout(function(){
                                    self.closeToast();  
                                },2000);
                            }

                        } else if (_code == 602) {
                            self.toast.contentShow = 2;
                        } else if (_code == 600) {
                            window.Login(KNB);
                            // window.Login(function () {
                            //     window.location.reload();
                            //     console.log("chenggong");

                            // }, function () {
                            //     alert("登入失败")
                            // });
                            return;
                        } else if (_code == 603) {
                            alert(_msg.string);
                        } else {
                            alert(_msg.string);
                        }
                    }, function () {
                        console.log('服务繁忙,请稍后再试T_T');
                    });

            },
            getVericode() {
                if (this.veriBtnTxt == '获取验证码') {
                    let time = 60;
                    let tId = setInterval(() => {
                        time--;

                        if (time <= 0) {
                            clearInterval(tId);
                            this.veriBtnTxt = '获取验证码';
                        } else {
                            this.veriBtnTxt = time + 's';
                        }

                    }, 1000);

                    // data
                    data.action = 'phoneVerifyCode';
                    data.token = '';
                    data.dpid = '';
                    data.phone = this.toast.mobile;
                    // data
                    // 发送请求
                    Vue.http.jsonp(url,
                        {　　//请求参数
                            params: data
                        }).then(function (res) {
                            let _resBody = res.body,
                                _code = _resBody.code,
                                _msg = _resBody.msg;

                            console.log(_msg.string);

                        }, function () {
                            console.log('服务繁忙,请稍后再试T_T');
                        });
                }

            },
            lotteryfn() {
                let self = this;
                data.mobile = this.toast.mobile;
                data.source = "";
                data.method = 'lottery';
                data.cityid = this.toast.cityId;
                this.lingxiClick(0,'b_4kuvlqb6');
                // jsonp
                Vue.http.jsonp(url,
                    {　　//请求参数
                        params: data
                    }).then(function (res) {
                        let _resBody = res.body,
                            _code = _resBody.code,
                            _msg = _resBody.msg;

                        if (_code == 200) {
                            if (_msg.prize === null) {
                                self.toast.contentShow = 11;
                            } else {
                                switch (_msg.prize.prizeName) {
                                    case "大牌口红1支":
                                        self.toast.contentShow = 5;
                                        self.priceText = "大牌口红1支";
                                        break;
                                    case "面膜":
                                        self.toast.contentShow = 6;
                                        self.priceText = "面膜";
                                        break;
                                    case "鲜花一束":
                                        self.toast.contentShow = 7;
                                        self.priceText = "鲜花一束";
                                        break;
                                    case "5元通用券":
                                        self.toast.contentShow = 8;
                                        self.priceText = "5元通用券"
                                        break;
                                    case "520元结婚抵用券":
                                        self.toast.contentShow = 9;
                                        self.priceText = "520元结婚抵用券"
                                        break;
                                    case "日本樱花季旅拍":
                                        self.toast.contentShow = 10;
                                        self.priceText = "日本樱花季旅拍"
                                        break;
                                    default:
                                        return;
                                }
                            }

                        } else if (_code == 600) {
                            //登录
                            window.Login(KNB);
                            // window.Login(function () {
                        //     window.location.reload();
                        //     console.log("chenggong");

                        // }, function () {
                        //     alert("登入失败")
                        // });
                return;
            } else {
                alert(_msg.string);
            }
        }, function() {
            console.log('服务繁忙,请稍后再试T_T');
        });
    }
        }
    }

</script>
<style lang="less" scoped>
    @import '../../../less/base/util.less';
    .toast-module {
        position: fixed;
        left: 0rem;
        top: 0rem;
        bottom: 0rem;
        right: 0rem;
        z-index: 10;
        .size(100%, 100%);
        background: rgba(0, 0, 0, .8);
        .toast-appointment {
            position: absolute;
            bottom: 0px;
            background: #fff;
            padding: 0.2rem 0.38rem 0.29rem 0.39rem;
            .close {
                position: absolute;
                display: inline-block;
                width: 0.1rem;
                height: 0.1rem;
                right: -.3rem;
                top: -.15rem;
                text-align: center;
            }
            p {
                font-size: 0.1rem;
                color: #666;
                margin-bottom: 0.05rem;
                position: relative;
                .close {
                    position: absolute;
                    display: inline-block;
                    width: 0.1rem;
                    height: 0.1rem;
                    right: -.3rem;
                    top: -.15rem;
                    text-align: center;
                    font-size: 0.16rem;
                }
            }
            input {
                margin-top: 0.05rem;
                width: 2.97rem;
                height: .315rem;
                border: 1px solid #ccc;
                text-indent: 0.065rem;
                font-size: 0.12rem;
            }
            span {
                color: #fe677e;
                display: inline-block;
                padding: 0.04rem 0.05rem;
                border-radius: 0.04rem;
                margin-right: 0.05rem;
            }
            .btn {
                background-color: #fe677e;
                color: #fff;
                width: 3rem;
                text-align: center;
                padding: 0.135rem 0rem;
                border-radius: 0.04rem;
                margin-top: 0.15rem;
                font-weight: 600;
            }
        }
        .toast-verification {
            position: absolute;
            bottom: 0px;
            background: #fff;
            padding: 0.31rem 0.38rem 0.29rem 0.39rem;
            font-size: 0.12rem;
            color: #666;
            .close {
                position: absolute;
                display: inline-block;
                width: 0.1rem;
                height: 0.1rem;
                right: 0.1rem;
                bottom: 1.40rem;
                text-align: center;
                color: #fe677e;
                border: 1px solid #fe677e;
                border-radius: 0.1rem;
                padding: 0.05rem;
            }
            p {
                margin-bottom: 0.05rem;
            }
            .input {
                margin-bottom: .15rem;
            }
            input {
                min-width: 1.90rem;
                border: 1px solid #ccc;
                text-indent: 0.065rem;
                font-size: 0.12rem;
                padding: 0.1rem 0rem;
                margin-right: 0.1rem;
            }
            .btn-verification {
                padding: .1rem .125rem;
                border: 1px solid #fe677e;
                color: #fe677e;
                width: 0.65rem;
                text-align: center;
                display: inline-block;
                border-radius: 0.04rem;
            }
            .btn {
                background-color: #fe677e;
                color: #fff;
                width: 3rem;
                text-align: center;
                padding: 0.135rem 0rem;
                border-radius: 0.04rem;
                margin-top: 0.15rem;
                font-weight: 600;
                font-size: 0.14rem;
            }
        }
        .toast-null {
            position: fixed;
            top: 50%;
            left: 50%;
            width: 2.78rem;
            height: 2.09rem;
            background: url(../img/null.png)no-repeat center;
            margin-top: -1.045rem;
            margin-left: -1.39rem;
            background-size: contain;
            .toast-null-conatiner {
                position: relative;
                height: 100%;
            }
            .close {
                position: absolute;
                height: 0.2rem;
                width: 0.2rem;
                right: 0.15rem;
            }
            .btn {
                position: absolute;
                bottom: 0.2rem;
                height: 0.4rem;
                width: 60%;
                margin: 0 20%;
            }
        }
        .toast-over {
            position: fixed;
            top: 50%;
            left: 50%;
            width: 2.78rem;
            height: 2.09rem;
            background: url(../img/over.png)no-repeat center;
            margin-top: -1.045rem;
            margin-left: -1.39rem;
            background-size: contain;
            .toast-over-conatiner {
                position: relative;
                height: 100%;
            }
            .close {
                position: absolute;
                height: 0.2rem;
                width: 0.2rem;
                right: 0.15rem;
            }
            .btn {
                position: absolute;
                bottom: 0.2rem;
                height: 0.4rem;
                width: 60%;
                margin: 0 20%;
            }
        }
        .toast-success-price {
            position: fixed;
            top: 50%;
            left: 50%;
            width: 2.4rem;
            height: 3.5rem;
            background: url(../img/success.png)no-repeat center;
            margin-top: -1.75rem;
            margin-left: -1.2rem;
            background-size: contain;
            .toast-price-conatiner {
                position: relative;
                height: 100%;
            }
            .close {
                position: absolute;
                height: 0.2rem;
                width: 0.2rem;
                /*background:red;*/
                right: 0rem;
            }
            .btn {
                position: absolute;
                bottom: 0rem;
                height: 0.47rem;
                width: 2.2rem;
                /*margin:0 10%;*/
                /*background:red;*/
            }
        }
        .toast-lipstick-price,
        .toast-mask-price,
        .toast-flower-price,
        .toast-5-price,
        .toast-520-price {
            position: fixed;
            top: 50%;
            left: 50%;
            width: 2.4rem;
            height: 3.5rem;
            background: url(../img/price.png)no-repeat center;
            margin-top: -1.75rem;
            margin-left: -1.2rem;
            background-size: contain;
            .toast-price-conatiner {
                position: relative;
                height: 100%;
            }
            .price-text {
                position: absolute;
                height: 0.35rem;
                /*width:2.2rem;*/
                line-height: 0.35rem;
                width: 100%;
                color: #fe677e;
                text-align: center;
                top: 0.4rem;
                font-size: 0.15rem;
                font-weight: 600;
            }
            .price-img {
                position: absolute;
                background: url(../img/lipstick.png)no-repeat center;
                background-size: contain;
                top: 1.2rem;
                height: 1.25rem;
                width: 0.89rem;
                left: 0.6rem;
            }
            .close {
                position: absolute;
                height: 0.2rem;
                width: 0.2rem;
                /*background:red;*/
                right: 0rem;
            }
            .btn {
                position: absolute;
                bottom: 0rem;
                height: 0.47rem;
                width: 2.2rem;
                /*margin:0 10%;*/
                /*background:red;*/
            }
        }
        .toast-big-price {
            position: fixed;
            top: 50%;
            left: 50%;
            width: 2.4rem;
            height: 3.5rem;
            background: url(../img/bigprice.png)no-repeat center;
            margin-top: -1.75rem;
            margin-left: -1.2rem;
            background-size: contain;
            .toast-price-conatiner {
                position: relative;
                height: 100%;
            }
            .price-text {
                position: absolute;
                height: 0.35rem;
                /*width:2.2rem;*/
                line-height: 0.35rem;
                width: 100%;
                color: #fe677e;
                text-align: center;
                top: 0.4rem;
                font-size: 0.15rem;
                font-weight: 600;
            }
            .close {
                position: absolute;
                height: 0.2rem;
                width: 0.2rem;
                /*background:red;*/
                right: 0.1rem;
                top: 0.2rem;
            }
            .btn {
                position: absolute;
                bottom: 0.17rem;
                height: 0.40rem;
                width: 2.2rem;
                /*margin:0 10%;*/
                /*background:red;*/
            }
        }
        .toast-mask-price {
            .price-img {
                position: absolute;
                background: url(../img/mask.png)no-repeat center;
                background-size: contain;
                top: 1.3rem;
                height: 1.25rem;
                width: 0.89rem;
                left: 0.7rem;
            }
        }
        .toast-flower-price {
            .price-img {
                position: absolute;
                background: url(../img/flowers.png)no-repeat center;
                background-size: contain;
                top: 1.3rem;
                height: 1.25rem;
                width: 0.89rem;
                left: 0.7rem;
            }
        }
        .toast-5-price {
            .price-img {
                position: absolute;
                background: url(../img/5.png)no-repeat center;
                background-size: contain;
                top: 1.3rem;
                height: 1.25rem;
                width: 0.89rem;
                left: 0.7rem;
            }
        }
        .toast-520-price {
            .price-img {
                position: absolute;
                background: url(../img/520.png)no-repeat center;
                background-size: contain;
                top: 1.3rem;
                height: 1.25rem;
                width: 0.89rem;
                left: 0.7rem;
            }
        }
        .isTopshow {
            animation: successAnimation 1.5s 1 linear;
            -webkit-animation: successAnimation 1.5s 1 linear;
        }
        .isRotate {
            animation: rotateAnimation 1.5s 1 linear;
            -webkit-animation: rotateAnimation 1.5s 1 linear;
        }
        /*奖品掉落动画*/
        @keyframes successAnimation {
            0% {
                top: 0rem;
            }
            25% {
                top: 20%;
            }
            50% {
                top: 50%;
            }
            80% {
                top: 45%;
            }
            90% {
                top: 46%;
            }
            100% {
                top: 50%;
            }
        }
        @-webkit-keyframes successAnimation {
            0% {
                top: 0rem;
            }
            25% {
                top: 20%;
            }
            50% {
                top: 50%;
            }
            80% {
                top: 45%;
            }
            90% {
                top: 46%;
            }
            100% {
                top: 50%;
            }
        }
        /*奖品旋转动画*/
        @keyframes rotateAnimation {
            0% {
                transform: rotateY(0);
                -webkit-transform: rotateY(0);
            }
            100% {
                transform: rotateY(360deg);
                ;
                -webkit-transform: rotateY(360deg);
                ;
            }
        }
        @-webkit-keyframes rotateAnimation {
            0% {
                transform: rotateY(0);
                -webkit-transform: rotateY(0);
            }
            100% {
                transform: rotateY(360deg);
                ;
                -webkit-transform: rotateY(360deg);
                ;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// toast.vue?bb1c60c0